import { render, staticRenderFns } from "./CheckBeforeSortAdd.vue?vue&type=template&id=2c1f0497&scoped=true&"
import script from "./CheckBeforeSortAdd.vue?vue&type=script&lang=js&"
export * from "./CheckBeforeSortAdd.vue?vue&type=script&lang=js&"
import style0 from "./CheckBeforeSortAdd.vue?vue&type=style&index=0&id=2c1f0497&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1f0497",
  null
  
)

export default component.exports